import React from 'react';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';

const CharacterList = (props) => (
  <Table
    fetching={props.fetching}
    columns={[
      {
        label: 'Academic Plan',
        path: 'academicPlan.name',
        width: '110px',
      },
      {
        label: 'Accent',
        path: 'accent',
        width: '120px',
      },
      {
        label: 'Name',
        path: 'name',
      },
      {
        label: 'Characteristcs',
        path: 'imagePrompt',
      },
      {
        label: 'Actions',
        path: 'action',
        width: '105px',
        render: (cell, row) => {
          return (
            <div>
              <Button icon="delete" onClick={() => props.onDelete(row)} />{' '}
              <Button icon="edit" onClick={() => browserHistory.push(`/characters/${row.id}`)} />
            </div>
          );
        },
      },
    ]}
    rows={props.characters}
    pagination={props.pagination}
    onChange={props.onChange}
  />
);

CharacterList.propTypes = {
  characters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  fetching: PropTypes.bool.isRequired,
  pagination: PropTypes.shape({
    current: PropTypes.number,
    total: PropTypes.number,
    pageSize: PropTypes.number,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CharacterList;
